var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('GenericCrud',{attrs:{"route-name":"SettingsGroupsOfPerson","route-action":"list","navbar-title":_vm.$t('settings.groupsOfPersons.buttonLabel'),"navbar-back-route-without-history":{ name: 'Settings' },"main-list-filter-label":_vm.$t('settings.groupsOfPersons.filterLabel'),"main-fist-scroll-to-selected":"","new-item-model-fields":{
            clientId: null,
            locale: _vm.currentLanguage,
            translations: _vm.defaultTranslations

        },"store-data":{
            store: 'groupsOfPersons',
            mainListItems: {
                action: 'groupsOfPersons/fetch',
                payload: { force: true },
                options: null,
                itemText: 'title'
            },
            mainItemById: {
                action: 'groupsOfPersons/fetchById',
                payload: null,
                options: null,
            },
            edit: {
                action: 'groupsOfPersons/edit',
                payload: null,
                options: null,
                refetch: true,
                hideButton: true
            },
            add: {
                action: 'groupsOfPersons/create',
                payload: null,
                options: null,
            },
            delete: {
                action: 'groupsOfPersons/delete',
                payload: null,
                options: null,
                hideButton: true
            },
            findUsage: {
                action: 'groupsOfPersons/findUsage',
                payload: null,
                options: null,
                hideButton: true
            },
            replace: {
                action: 'groupsOfPersons/replaceItemInRecord',
                options: null,
                hideButton: true
            },
        }},scopedSlots:_vm._u([{key:"editorMask",fn:function(x){return [_c('EditorMask',{key:x.id,attrs:{"available-languages":_vm.availableLanguages,"current-language":_vm.currentLanguage,"isWaiting":x.isWaiting,"isModified":x.isModified},on:{"modified":x.onSetModified,"onSaveItem":x.onSaveItem,"onDeleteItem":x.onDeleteItem,"onFindUsage":x.onFindUsage,"onCreateItem":x.onCreateItem},model:{value:(x.selectedMainItem),callback:function ($$v) {_vm.$set(x, "selectedMainItem", $$v)},expression:"x.selectedMainItem"}})]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }